import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { TextArea, TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import { DatePicker, Stack } from "rsuite";
import { FormattedMessage } from "react-intl";

export interface ConfirmProps {
  description?: string;
  successText: string;
  failureText: string;
  cancelText?: string;
  onSuccess: () => void;
  onFailure: () => void;
  onCancel?: () => void;
  className?: string;
  textBoxRequired?: boolean;
  datePickerRequired?: boolean;
  intialTextValue?: string;
  textBoxValue?: (e: string) => void;
  icon?: any;
  iconMsg?: string;
  backgroundColor?: string;
}

export function Confirm(props: ConfirmProps) {
  console.log("print the icon file", props.icon);
  console.log("print the icon message", props.iconMsg);
  console.log("print the description", props.description);
  console.log("background color", props.backgroundColor);
  const [textValue, setTextValue] = React.useState(props.intialTextValue);

  const changeTextValue = (e: TextAreaChangeEvent) => {
    setTextValue(e.value);
    props.textBoxValue!!(e.value);
  };

  console.log("icon image in confirm", props?.icon);
  return (
    <div className={`flex flex-col space-y-2 ${props.className}`}>
      <div className="flex space-x-2 items-center justify-center">
        {props?.icon && <img src={props?.icon} alt="icon" />}

        <div className={`text-2xl text-${props?.backgroundColor} text-center`}>
          {props.iconMsg}
        </div>
      </div>

      {props?.backgroundColor === "mk-bright-green" && (
        <div
          className={`border-b border-2 border-mk-bright-green w-full`}
        ></div>
      )}
      {props?.backgroundColor === "mk-red" && (
        <div className={`border-b border-2 border-mk-red w-full`}></div>
      )}
      {props?.backgroundColor === "mk-orange" && (
        <div className={`border-b border-2 border-mk-orange w-full`}></div>
      )}

      {props.textBoxRequired ? (
        <TextArea
          value={textValue}
          onChange={(e: TextAreaChangeEvent) => changeTextValue(e)}
        />
      ) : (
        <div className="p-1 text-base text-left">{props.description}</div>
      )}
      {props.datePickerRequired ? (
        <div>
          <Stack spacing={6}>
            <FormattedMessage id="fromTime" />
            <DatePicker format="yyyy-MM-dd HH:mm:ss" />
            <FormattedMessage id="tillTime" />
            <DatePicker format="yyyy-MM-dd HH:mm:ss" />
          </Stack>
        </div>
      ) : (
        <div></div>
      )}

      <div className="flex space-x-4 justify-center pb-2 pt-4">
        <Button themeColor="primary" onClick={() => props.onSuccess()}>
          {props.successText}
        </Button>
        <Button themeColor="primary" onClick={() => props.onFailure()}>
          {props.failureText}
        </Button>
        {props.cancelText && props.onCancel && (
          <Button
            themeColor="primary"
            onClick={() => props.onCancel && props.onCancel()}
          >
            {props.cancelText}
          </Button>
        )}
      </div>
    </div>
  );
}
